export default __webpack_public_path__ + "static/Survive-Japan-Knowing-Only-English-Ask-A-Local-6001dd3b16ce1a1d1db31f7d80f7ceba.jpg";